;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.entity.list')
    .controller('EntityListToolbarController', EntityListToolbarController)

  EntityListToolbarController.$inject = [
    // Angular
    '$uibModal', '$state',

    // Services
    'EntityService', 'PreferencesService'

  ]

  function EntityListToolbarController (
    // Angular
    $uibModal, $state,

    // Services
    EntityService,
    PreferencesService

  ) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        createEntity: createEntity,
        init: init,
        requiredForExport: false
      })

      init()
    }

    function init () {
      PreferencesService.getCompanyPrefs().then(function (companyPrefs) {
        self.requiredForExport = _.get(companyPrefs, 'enabledFeatures.requiredForExport')
      })
    }
    function createEntity () {
      EntityService.createEntity(self.parent, ['Individual', 'Organization', 'Agency'], { from: 'sufa', entityAccountRequired: self.requiredForExport }).then(function (data) {
        $state.reload()
      })
    }
  }
})(window.angular, window._)
